// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__2eqgE","header":"ReportDetails_header__fmHY_","title":"ReportDetails_title__38WJQ","left":"ReportDetails_left__1X7wi"};